import request from '@/assets/js/request'

let dPatch = process.env.NODE_ENV === 'production' ? '/api' : '';

// 图片上传
export function imageFileUpload (data) {
    return request({
        url: dPatch + '/file/imageFileUpload',
        method: 'post',
        data
    })
}

// 图片上传base
export function uploadFileBase (data) {
    return request({
        url: dPatch + '/file/uploadFileBase',
        method: 'post',
        data
    })
}

// 图片删除
export function removeImg (data) {
    return request({
        url: dPatch + '/file/removeImg',
        method: 'post',
        data
    })
}

// 我的车-列表查询
export function queryMyElectricCar (data) {
    return request({
        url: dPatch + '/wechatelectrocar/queryMyElectricCar',
        method: 'post',
        data
    })
}

// 我的车-添加车辆
export function insertElectrocar (data) {
    return request({
        url: dPatch + '/wechatelectrocar/insertElectrocar',
        method: 'post',
        type: 'json',
        data
    })
}

// 电动车-详情
export function queryMyElectricCarInfo (data) {
    return request({
        url: dPatch + '/wechatelectrocar/queryMyElectricCarInfo',
        method: 'post',
        data
    })
}

// 添加骑行人
export function insertRiding (data) {
    return request({
        url: dPatch + '/riding/insertRiding',
        method: 'post',
        data
    })
}

// 删除骑行人
export function deleteRidingById (data) {
    return request({
        url: dPatch + '/riding/deleteRidingById',
        method: 'post',
        data
    })
}

// 报失
export function updateLossMyCar (data) {
    return request({
        url: dPatch + '/wechatelectrocar/updateLossMyCar',
        method: 'post',
        data
    })
}


// 取消报失
export function cancelLossMyCar (data) {
    return request({
        url: dPatch + '/wechatelectrocar/cancelLossMyCar',
        method: 'post',
        data
    })
}


// 我的扫码列表
export function queryMyScanCodePage (data) {
    return request({
        url: dPatch + '/scan/queryMyScanCodePage',
        method: 'post',
        data
    })
}


// 扫一扫-电动车信息
export function scanCode (data) {
    return request({
        url: dPatch + '/scan/scanCode',
        method: 'post',
        data
    })
}

// 警务-扣车
export function detainCar (data) {
    return request({
        url: dPatch + '/scan/detainCar',
        method: 'post',
        data
    })
}

// 线索追踪接口列表
export function queryMyPoliceCluePage (data) {
    return request({
        url: dPatch + '/clueTracking/queryMyPoliceCluePage',
        method: 'post',
        data
    })
}

// 线索详情
export function getOnlyClueInfo (data) {
    return request({
        url: dPatch + '/clueTracking/getOnlyClueInfo',
        method: 'post',
        data
    })
}

// 警务提交线索确认接口
export function doCluePolice (data) {
    return request({
        url: dPatch + '/clueTracking/doCluePolice',
        method: 'post',
        data
    })
}



// 车主信息修改
export function updateUser (data) {
    return request({
        url: dPatch + '/user/updateUser',
        method: 'post',
        type: 'json',
        data
    })
}

// 报警
export function callPolice (data) {
    return request({
        url: dPatch + '/scan/callPolice',
        method: 'post',
        type: 'json',
        data
    })
}


// 警务加车
export function qrCodeHandelValidCar (data) {
    return request({
        url: dPatch + '/wechatelectrocar/qrCodeHandelValidCar',
        method: 'post',
        type: 'json',
        data
    })
}
// 警务加人
export function insertElectrocarAndUser (data) {
    return request({
        url: dPatch + '/wechatelectrocar/insertElectrocarAndUser',
        method: 'post',
        type: 'json',
        data
    })
}

// 申请合作
export function insertIntention (data) {
    return request({
        url: dPatch + '/intention/insert',
        method: 'post',
        type: 'json',
        data
    })
}


// 查询保函详情
export function queryGuaranteeDetailByNo (data) {
    return request({
        url: dPatch + '/guarantee/queryDetailByNo',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/myCar.js